import { mouseStore, useMousePosition } from '@shared/hooks/use-mouse-position'
import { useEffect } from 'react'
import { FlowNodeIconClass } from '../config/panel.config'
import { useTypedReactFlow } from '../hooks/use-react-flow'
import { useFlowStore } from '../store'
import { FlowNodeTypes } from '../types'
import { CandidateNode } from './candidate-node'
import { CandidateNote } from './candidate-note'

export const Candidate = () => {
  const { mousePosition, handleMouseMove } = useMousePosition()
  const candidateNode = useFlowStore((state) => state.candidateNode)
  const { addNodes, screenToFlowPosition, getNodes } = useTypedReactFlow()
  const setCandidateNode = useFlowStore((state) => state.setCandidateNode)
  const selectNode = useFlowStore((state) => state.selectNode)

  const handleMouseClick = () => {
    if (candidateNode) {
      const position = screenToFlowPosition(mouseStore.getState().mousePosition)
      setCandidateNode(null)

      let zIndex = 1 // Default z-index for most nodes

      // Special handling for note nodes to layer them properly
      if (candidateNode.type === FlowNodeTypes.note) {
        const noteNodes = getNodes().filter((node) => node.type === FlowNodeTypes.note)
        // Calculate z-index to layer notes from back to front based on creation order
        zIndex = 100 + (noteNodes.length || 0)
      }

      addNodes([{ ...candidateNode, position, zIndex }])
      selectNode(candidateNode.id)
    }
  }

  const removeListeners = () => {
    document.removeEventListener('mousemove', handleMouseMove)
    document.removeEventListener('click', handleMouseClick)
  }

  useEffect(() => {
    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('click', handleMouseClick)
    return () => {
      removeListeners()
    }
  }, [candidateNode])

  if (!candidateNode) return null

  // Get the node configuration for styling and icon
  const nodeConfig = FlowNodeIconClass[candidateNode.type as FlowNodeTypes]
  const isNoteNode = candidateNode.type === FlowNodeTypes.note

  // For note nodes, use the CandidateNote component
  if (isNoteNode) {
    return <CandidateNote mousePosition={mousePosition} />
  }

  // For regular nodes, use the CandidateNode component
  return (
    <CandidateNode
      candidateNode={candidateNode}
      mousePosition={mousePosition}
      nodeConfig={nodeConfig}
    />
  )
}
